/* eslint-disable import/no-extraneous-dependencies */
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Button } from "@repo/ui";
import { createRef } from "react";
import { useGetRoutePackages } from "utils/apis/daily-operations";
import { FaFileExcel } from "react-icons/fa";

export function RequestDetails({ routeNo, cashCenterId, operationDate }) {
  const { data: routePackages } = useGetRoutePackages({
    routeNo,
    operationDate,
    cashCenterId,
    shift: "morning",
  });
  const _export = createRef();
  const onExport = () => {
    if (_export?.current) {
      _export.current.save();
    }
  };
  return (
    <>
      <div className="flex flex-row justify-end items-end">
        <Button
          variant="secondary"
          onClick={() => {
            onExport();
          }}
        >
          <FaFileExcel />
          <span className="pl-2">Export</span>
        </Button>
      </div>
      <Grid
        className="text-xs w-full overflow-scroll h-[60vh]"
        data={routePackages || []}
        sortable
        filterable
        size="small"
      >
        <GridColumn field="orderId" title="Order Id" width={160} />
        <GridColumn field="jobNo" title="JobNo" width={160} />
        <GridColumn field="bagType" title="Bag Type" width={160} />
        <GridColumn field="bagId" title="Bag Id" width={160} />
        <GridColumn
          field="sourceBarcode"
          title="From Location Barcode"
          width={250}
        />
        <GridColumn field="sourceName" title="From Location Name" width={250} />
        <GridColumn
          field="destinationBarcode"
          title="To Location Barcode"
          width={250}
        />
        <GridColumn
          field="destinationName"
          title="To Location Name"
          width={250}
        />
        <GridColumn field="sealNo" title="Seal No" width={160} />
        <GridColumn field="currency" title="Currency" width={160} />
        <GridColumn field="declaredValue" title="Declared Value" width={160} />
      </Grid>
      <ExcelExport
        data={routePackages || []}
        ref={_export}
        fileName="Packages.xlsx"
      >
        <GridColumn field="orderId" title="Order Id" width={160} />
        <GridColumn field="jobNo" title="JobNo" width={160} />
        <GridColumn field="bagType" title="Bag Type" width={160} />
        <GridColumn field="bagId" title="Bag Id" width={160} />
        <GridColumn
          field="sourceBarcode"
          title="From Location Barcode"
          width={250}
        />
        <GridColumn field="sourceName" title="From Location Name" width={250} />
        <GridColumn
          field="destinationBarcode"
          title="To Location Barcode"
          width={250}
        />
        <GridColumn
          field="destinationName"
          title="To Location Name"
          width={250}
        />
        <GridColumn field="sealNo" title="Seal No" width={160} />
        <GridColumn field="currency" title="Currency" width={160} />
        <GridColumn field="declaredValue" title="Declared Value" width={160} />
      </ExcelExport>
    </>
  );
}
